export default __webpack_public_path__ + "static/smellsLikeSpaceCandy-b5f1af35ccac88d9e15690b3805fb8db.png";